import { Avatar, Card, Col, Layout, Row, Rate } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import Sidebar from "./sidebar";
import { useSelector } from "react-redux";
import { getImgUrl } from "../../../utils";
const { Content } = Layout;

const DriverLayout = ({
  children,
  driverId,
}: {
  children: ReactElement;
  driverId: string;
}): ReactElement => {
  const { driverInfo } = useSelector((state) => (state as any)?.authReducer);
  return (
    <React.Fragment>
      <Layout className="min-vh-100">
        <section className="">
          <Row gutter={16}>
            <Col span={6}>
              <Card
                className="shop-sedebar card-padding-none h-100"
                cover={
                  <div className="show-details-inner-content">
                    <div className="shop-image-content">
                      <div className="pt-4">
                        <div className="">
                          <Avatar
                            size={150}
                            src={getImgUrl(driverInfo?.image)}
                          />
                        </div>
                        <div className="pt-3">
                          <h4>{driverInfo?.name?.toUpperCase()}</h4>
                          <div className="mb-2">
                            <div>
                              <span
                                className="radius-btn active-btn px-5"
                                style={{ fontSize: 14 }}
                              >
                                <span>
                                  Balance: &#2547;
                                  {parseInt(driverInfo?.balance) || 0}
                                </span>
                              </span>
                            </div>
                            <Rate
                              value={driverInfo?.rating || 0}
                              className="mt-1"
                              disabled
                            />
                            <small className="ml-1">
                              ({driverInfo?.numberOfRating || 0})
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              >
                <Sidebar driverId={driverId} />
              </Card>
            </Col>
            <Col span={18}>
              <Card className="product-information-show-tab-wrapper" size="small">
                <Layout>
                  <Content className="main-content-layout">{children}</Content>
                </Layout>
              </Card>
            </Col>
          </Row>
        </section>
      </Layout>
    </React.Fragment>
  );
};

DriverLayout.propType = {
  children: PropTypes.element,
};

export default DriverLayout;
